/* tslint:disable */
import { NetworkError } from "../../Errors/NetworkError";
import { ValueError } from "../../Errors/ValueError";
import { StyleBuilder } from "../../utils/StyleBuilder";
function isDST(date) {
    function stdTimezoneOffset(date) {
        var jan = new Date(date.getFullYear(), 0, 1);
        var jul = new Date(date.getFullYear(), 6, 1);
        return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    }
    return date.getTimezoneOffset() < stdTimezoneOffset(date);
}
/**
 * Represents a single series of data
 */
export class GraphDataClass {
    constructor(timeSeries, values, thresholds) {
        if (timeSeries.length !== values.length) {
            throw new ValueError("Array lengths must agree!");
        }
        this.timeSeries = timeSeries; // TODO: make this timeSeries.slice() to copy by value
        this.values = values; // TODO: make this values.slice() to copy by value
        this.thresholds = thresholds;
    }
    get maxDate() {
        return this.timeSeries[this.timeSeries.length - 1];
    }
    get minDate() {
        return this.timeSeries[0];
    }
    get maxValue() {
        //@ts-ignore
        return Math.max(...this.values);
    }
    get minValue() {
        //@ts-ignore
        return Math.min(...this.values);
    }
    get length() {
        if (this.timeSeries.length !== this.values.length)
            throw new Error("Lengths of data were not the same");
        return this.values.length;
    }
    roundAllValues(numberOfDP = 2) {
        this.values = this.values.map(d => d === null ? null : Number.parseFloat(d.toFixed(numberOfDP)));
    }
    /**
     * Not tested, beware!
     * Useful for debugging, not used in main code.
     * @param timeStamp
     */
    getValueAtTimeStamp(timeStamp) {
        let index = this.timeSeries.indexOf(timeStamp);
        if (index === -1) {
            throw new ValueError(`No timestamp ${timeStamp} in this series`);
        }
        return this.values[index];
    }
    /**
     * Creates a chart dataset from this data
     * TODO: Make yAxisID compulsary
     * @returns
     */
    toChartDataset(styleName, yAxisID, altLabel) {
        let data = [];
        let dashedSettings = [];
        let chartDataset;
        for (let i = 0; i < this.timeSeries.length; i++) {
            data.push({ x: this.timeSeries[i], y: this.values[i] });
        }
        if (styleName !== undefined) {
            chartDataset = Object.assign({}, StyleBuilder.getStyle(styleName));
        }
        else {
            chartDataset = {};
        }
        chartDataset.data = data;
        chartDataset.yAxisID = yAxisID;
        if (altLabel) {
            chartDataset.label = this.toTitleCase(altLabel).replace(' Me', ' ME').replace(' Ecmwf', ' ECMWF');
        }
        else {
            if (styleName !== undefined) {
                chartDataset.label = this.toTitleCase(styleName).replace(' Me', ' ME').replace(' Ecmwf', ' ECMWF');
            }
        }
        return { chartDataset: chartDataset, thresholds: this.thresholds !== undefined ? this.thresholds : [] };
    }
    toTitleCase(str) {
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }
    filterByTimeSeries(filterSeries) {
        let filteredTimeSeries = [];
        let filteredValues = [];
        filterSeries.timeSeries.forEach(time => {
            if (this.timeSeries.indexOf(time) !== -1) {
                filteredTimeSeries.push(time);
                filteredValues.push(this.getValueAtTimeStamp(time));
            }
        });
        let x = new GraphDataClass(filteredTimeSeries, filteredValues);
        x.forecastTime = this.forecastTime;
        return x;
    }
    /**
     * Hacky, but so long as we obey string ISO formats, this will work.
     * @param minTime
     * @param maxTime
     * @returns
     */
    filterByMinMaxDate(minTime, maxTime) {
        let filteredTimeSeries = [];
        let filteredValues = [];
        for (let i = 0; i < this.timeSeries.length; i++) {
            if (this.timeSeries[i] >= minTime && this.timeSeries[i] <= maxTime) {
                filteredTimeSeries.push(this.timeSeries[i]);
                filteredValues.push(this.values[i]);
            }
        }
        return new GraphDataClass(filteredTimeSeries, filteredValues);
    }
    /**
     * Create new instance from APIResponse
     * @param apiResponse
     * @returns
     */
    static fromAPIResponse(apiResponse, localTimes = false) {
        if (apiResponse.timeSeries === undefined) {
            throw new NetworkError("Invalid API response");
        }
        let events;
        let forecastTime = undefined;
        if (apiResponse.summarySeries == true) {
            // If two timeseries are provided, take the longest one. 
            // The second one is likely to be a summary series.
            let goodTimeseries = apiResponse.timeSeries
                .find(d => d.events.length === Math.min(...apiResponse.timeSeries
                .map(d => d.events.length)));
            if (goodTimeseries === undefined) {
                throw new Error("No timeseries found!");
            }
            events = goodTimeseries.events;
            if (goodTimeseries.header.forecastDate !== undefined) {
                let d = new Date(`${goodTimeseries.header.forecastDate.date}T${goodTimeseries.header.forecastDate.time}Z`);
                forecastTime = d;
            }
        }
        else {
            // If two timeseries are provided, take the longest one. 
            // The second one is likely to be a summary series.
            events = apiResponse.timeSeries
                .find(d => d.events.length === Math.max(...apiResponse.timeSeries
                .map(d => d.events.length))).events;
        }
        let plotTimeSeries = { timeSeries: [], values: [] };
        let missingDataValue = apiResponse.timeSeries[0].header.missVal;
        events.forEach(event => {
            if (event.value === missingDataValue) {
                //@ts-ignore
                plotTimeSeries.values.push(null);
            }
            else {
                plotTimeSeries.values.push(Number.parseFloat(event.value));
            }
            let d = new Date(`${event.date}T${event.time}Z`);
            if (localTimes && isDST(d)) {
                let offset = d.getTimezoneOffset() * 60 * 1000; // negative
                d.setTime(d.getTime() - offset);
            }
            let valueToInsert = d.toISOString();
            //if (plotTimeSeries.timeSeries.includes(valueToInsert)) {
            //    console.warn(`${valueToInsert} already exists from ${event.date}T${event.time} `);
            //}
            plotTimeSeries.timeSeries.push(valueToInsert);
        });
        let graphdataclass = new GraphDataClass(plotTimeSeries.timeSeries, plotTimeSeries.values, apiResponse.timeSeries[0].header.thresholds);
        graphdataclass.forecastTime = forecastTime;
        return graphdataclass;
    }
    /**
     * Extends the start date of the series.
     * @param startDate
     */
    setStartDate(startDate) {
        let wantedStartDate = new Date(startDate);
        let currentStartDate = new Date(this.timeSeries[0]);
        if (currentStartDate > wantedStartDate) {
            let difference = currentStartDate.getTime() - wantedStartDate.getTime();
            let timesteps = difference / 1000 / 60 / 15;
            while (timesteps > 0) {
                currentStartDate.setMinutes(currentStartDate.getMinutes() - 15);
                this.timeSeries.unshift(currentStartDate.toISOString());
                //@ts-ignore
                this.values.unshift(null);
                timesteps -= 1;
            }
        }
        // else do nothing, yet.
        // else if (currentStartDate < wantedStartDate) {
        //     let difference = wantedStartDate.getTime() - currentStartDate.getTime();
        //     let timesteps = difference/ 1000 / 60 /15;
        //     while(timesteps > 0) {
        //         currentStartDate.setMinutes(currentStartDate.getMinutes() + 15);
        //         this.timeSeries.push(currentStartDate.toISOString());
        //         //@ts-ignore
        //         this.values.push(null);
        //         timesteps -=1;
        //     }
        // }
    }
    /**
     * Extends the enddate of the series
     * @param endDate
     */
    setEndDate(endDate) {
        let wantedEndDate = new Date(endDate);
        let currentEndDate = new Date(this.timeSeries[this.timeSeries.length - 1]);
        if (currentEndDate < wantedEndDate) {
            let difference = wantedEndDate.getTime() - currentEndDate.getTime();
            let timesteps = difference / 1000 / 60 / 15;
            while (timesteps > 0) {
                currentEndDate.setMinutes(currentEndDate.getMinutes() + 15);
                this.timeSeries.push(currentEndDate.toISOString());
                //@ts-ignore
                this.values.push(null);
                timesteps -= 1;
            }
        }
    }
    /**
     * Sets the start and end date of the series - useful if you need to extend it past when it runs until.
     *
     * @param otherSeries
     */
    extendTimeSeries(startDate, endDate) {
        this.setStartDate(startDate);
        this.setEndDate(endDate);
    }
    /**
     * Takes another data class and merges its values based on the time series
     * @param other
     */
    mergeInPlace(other) {
        //TODO: just check first element, last element and length. 
        if (JSON.stringify(this.timeSeries) !== JSON.stringify(other.timeSeries)) {
            console.log(`Target series: ${this.timeSeries[0]} to ${this.timeSeries[this.timeSeries.length - 1]} with length: ${this.timeSeries.length}`);
            console.log(this.timeSeries);
            console.log(`Other series: ${other.timeSeries[0]} to ${other.timeSeries[other.timeSeries.length - 1]} with length: ${other.length}`);
            console.log(other.timeSeries);
            throw new ValueError("Time series were not equal!");
        }
        ;
        for (let i = 0; i < this.timeSeries.length; i++) {
            let currentValue = this.values[i];
            let otherValue = other.values[i];
            //TODO URGENT: Check this works?
            //@ts-ignore
            currentValue < otherValue ? this.values[i] = otherValue : undefined;
        }
    }
    /**
     * Merges and returns new instance of GraphDataClass
     * TODO: rename
     * @param other
     */
    mergenew(other) {
        var _a, _b;
        let originalValue = JSON.parse(JSON.stringify(this));
        let original = new GraphDataClass(originalValue.timeSeries, originalValue.values);
        if (JSON.stringify(this.timeSeries) !== JSON.stringify(other.timeSeries)) {
            throw new ValueError("Time series were not equal!");
        }
        ;
        for (let i = 0; i < original.timeSeries.length; i++) {
            let currentValue = original.values[i];
            let otherValue = other.values[i];
            if (currentValue == null && otherValue == null) {
                original.values[i] = null;
                continue;
            }
            else if (currentValue === null) {
                original.values[i] = otherValue;
                continue;
            }
            else if (otherValue === null) {
                original.values[i] = currentValue;
                continue;
            }
            currentValue < otherValue ? original.values[i] = otherValue : undefined;
        }
        let thresholds = [];
        (_a = this.thresholds) === null || _a === void 0 ? void 0 : _a.forEach(t => {
            thresholds === null || thresholds === void 0 ? void 0 : thresholds.push(t);
        });
        (_b = other.thresholds) === null || _b === void 0 ? void 0 : _b.forEach(t => {
            thresholds === null || thresholds === void 0 ? void 0 : thresholds.push(t);
        });
        if (thresholds.length === 0) {
            thresholds = undefined;
        }
        original.thresholds = thresholds;
        return original;
    }
    accumulate(offset, isObs, ignoreDate = false, maxHours = 0) {
        var _a;
        let originalValue = JSON.parse(JSON.stringify(this));
        let original = new GraphDataClass(originalValue.timeSeries, originalValue.values);
        let runningTotal = offset;
        let dtNow = Date.now();
        let d = new Date();
        d.setDate(d.getDate() - 2);
        let b = d.toString();
        //get date that date stops being provided (offset provided in hours)
        let dataEnd = new Date();
        //dataEnd.setDate(dataEnd.getTime() + 2);
        dataEnd.setTime(dataEnd.getTime() + (maxHours * 60 * 60 * 1000));
        console.log(maxHours + ' so ending data at ' + dataEnd.toString());
        let startDate = new Date();
        startDate.setDate(startDate.getDate() - 4);
        if (ignoreDate === true) {
            for (let i = 0; i < original.timeSeries.length; i++) {
                //only show data within 1 day of t0 as it's forecast only
                //if (i % 100 == 0) {
                //    console.log(i + ' time series date ' + original.timeSeries[i])
                //    console.log(i + ' checking date ' + b);
                //}
                if (Date.parse(b) < Date.parse(original.timeSeries[i]) && Date.parse(original.timeSeries[i]) < Date.parse(dataEnd.toString())) {
                    let currentValue = original.values[i];
                    runningTotal += currentValue;
                    original.values[i] = Math.round(runningTotal * 10) / 10;
                }
            }
        }
        else {
            console.log('in new logic checking vs. ' + startDate.toString());
            for (let i = 0; i < original.timeSeries.length; i++) {
                let currentValue = original.values[i];
                if (isObs == true && ignoreDate == false && dtNow > Date.parse(original.timeSeries[i])) {
                    // don't want to accumulate rain from more than 4 days ago
                    if (Date.parse(startDate.toString()) < Date.parse(original.timeSeries[i])) {
                        if (i % 100 == 0) {
                            console.log('loop date is ' + original.timeSeries[i].toString());
                            console.log(' adding ' + currentValue + ' to ' + runningTotal);
                        }
                        if (currentValue == null) {
                            //do nothing
                            original.values[i] = Math.round(runningTotal * 10) / 10;
                            continue;
                        }
                        else {
                            runningTotal += currentValue;
                            original.values[i] = Math.round(runningTotal * 10) / 10;
                        }
                    }
                    else {
                        if (i % 100 == 0) {
                            console.log(i + ' checking date not OK ' + original.timeSeries[i].toString());
                        }
                        original.values[i] = Math.round(runningTotal * 10) / 10;
                        continue;
                    }
                }
                else {
                    if (isObs == true && dtNow > Date.parse(original.timeSeries[i])) { //only interested if time we're looking at is greater than t0
                        if (i % 100 == 0) {
                            console.log(i + ' obs and date is greater than ' + original.timeSeries[i]);
                        }
                        if (currentValue == null) {
                            //do nothing
                            original.values[i] = Math.round(runningTotal * 10) / 10;
                            continue;
                        }
                        else {
                            runningTotal += currentValue;
                            original.values[i] = Math.round(runningTotal * 10) / 10;
                        }
                    }
                    else if (isObs == false) {
                        if (dtNow < Date.parse(original.timeSeries[i])) {
                            if (currentValue == null) {
                                //do nothing
                                original.values[i] = Math.round(runningTotal * 10) / 10;
                                continue;
                            }
                            else {
                                runningTotal += currentValue;
                                original.values[i] = Math.round(runningTotal * 10) / 10;
                            }
                        }
                        else {
                            //this stops forecast data reporting zeroes until t0
                            original.values[i] = null;
                        }
                    }
                }
            }
        }
        let thresholds = [];
        (_a = this.thresholds) === null || _a === void 0 ? void 0 : _a.forEach(t => {
            thresholds === null || thresholds === void 0 ? void 0 : thresholds.push(t);
        });
        if (thresholds.length === 0) {
            thresholds = undefined;
        }
        original.thresholds = thresholds;
        //set new property to access it later (needed for obs to forecast accumulations)
        original.trackedTotal = Math.round(runningTotal * 10) / 10;
        return original;
    }
    mergeandaccumulate(other) {
        var _a, _b;
        let originalValue = JSON.parse(JSON.stringify(this));
        let original = new GraphDataClass(originalValue.timeSeries, originalValue.values);
        if (JSON.stringify(this.timeSeries) !== JSON.stringify(other.timeSeries)) {
            throw new ValueError("Time series were not equal!");
        }
        ;
        let runningTotal = 0;
        for (let i = 0; i < original.timeSeries.length; i++) {
            let currentValue = original.values[i];
            let otherValue = other.values[i];
            if (currentValue == null && otherValue == null) {
                //do nothing
                //runningTotal = Math.round(runningTotal * 10) / 10;;
                //console.log(original.timeSeries[i] + ' doing nothing both null')
                original.values[i] = Math.round(runningTotal * 10) / 10;
                continue;
            }
            else if (currentValue === null) {
                if (otherValue != null) {
                    runningTotal += otherValue;
                    //console.log(original.timeSeries[i] + ' taking forecast');
                    original.values[i] = Math.round(runningTotal * 10) / 10;
                }
                continue;
            }
            else if (otherValue === null) {
                runningTotal += currentValue;
                //console.log(original.timeSeries[i] + ' taking observed');
                original.values[i] = Math.round(runningTotal * 10) / 10;
                continue;
            }
            else {
                runningTotal += currentValue;
                //console.log(original.timeSeries[i] + ' taking observed compare');
                original.values[i] = Math.round(runningTotal * 10) / 10;
            }
        }
        let thresholds = [];
        (_a = this.thresholds) === null || _a === void 0 ? void 0 : _a.forEach(t => {
            thresholds === null || thresholds === void 0 ? void 0 : thresholds.push(t);
        });
        (_b = other.thresholds) === null || _b === void 0 ? void 0 : _b.forEach(t => {
            thresholds === null || thresholds === void 0 ? void 0 : thresholds.push(t);
        });
        if (thresholds.length === 0) {
            thresholds = undefined;
        }
        original.thresholds = thresholds;
        return original;
    }
    getMaxValueBetween(startDate, endDate) {
        return this.filterByMinMaxDate(startDate.toISOString(), endDate.toISOString()).maxValue;
    }
    /**
     *
     *
     * @param maxOption If true, will take the maximum from the next 96 hours
     */
    getAlertLevel(minDate, maxDate) {
        if (this.thresholds === undefined) {
            throw new ValueError("Thresholds not defined");
        }
        let sortedThresholds = (this.thresholds.sort((a, b) => Number.parseFloat(a.value) - Number.parseFloat(b.value)));
        if (sortedThresholds.some(t => Number.isNaN(Number.parseFloat(t.value)))) {
            throw new ValueError("Some threshold had an invalid value (e.g. null)");
        }
        let currentThreshold = null;
        let currentValue;
        if (maxDate !== undefined) {
            currentValue = this.getMaxValueBetween(minDate, maxDate);
        }
        else {
            currentValue = this.getValueAtTimeStamp(minDate.toISOString());
        }
        if (currentValue === null) {
            throw new ValueError("Current value is null");
        }
        let currentValueNN = currentValue;
        let returnLabel = '';
        sortedThresholds.forEach(d => {
            if (currentValueNN >= Number.parseFloat(d.value)) {
                currentThreshold = d;
                returnLabel = currentThreshold.label;
            }
        });
        if (currentThreshold === null) {
            return "No Flood State";
        }
        else {
            return returnLabel;
        }
    }
    toCSV() {
        let csvContent = "data:text/csv;charset=utf-8,";
        for (let rowCount = 0; rowCount < this.timeSeries.length; rowCount++) {
            let row = this.timeSeries[rowCount] + "," + this.values[rowCount];
            //There is no string builder :( But according to this link
            // += will be almost as fast as array joins
            // https://stackoverflow.com/questions/2087522/does-javascript-have-a-built-in-stringbuilder-class
            csvContent += row + "\r\n";
        }
        return csvContent;
    }
}
